import axios from 'axios';
import {getApiConfig} from '../config/configProvider';
import {
  GQL_GET_ORDER_FEEDBACK_PRODUCTS,
  GQL_REVIEW_PROMPT,
  GQL_SNOOZE_REVIEW_PROMPT,
  GQL_SUBMIT_REVIEW,
} from '../gql/reviews.gql';

const postGraphQL = (query, variables, headers) => {
  const config = getApiConfig();
  return axios({
    url: config.graphQL,
    method: 'post',
    data: {query, variables},
    headers,
  }).then(res => res.data);
};

export default class ReviewsApi {
  static submitReview(variables, headers) {
    return postGraphQL(GQL_SUBMIT_REVIEW, variables, headers);
  }

  static getReviewPrompt(headers) {
    return postGraphQL(GQL_REVIEW_PROMPT, {}, headers);
  }

  static snoozeReviewPrompt(orderId, headers) {
    return postGraphQL(GQL_SNOOZE_REVIEW_PROMPT, {orderId}, headers);
  }

  static getOrderFeedbackProducts(itemIds, headers) {
    return postGraphQL(
      GQL_GET_ORDER_FEEDBACK_PRODUCTS,
      {itemIds, size: itemIds.length},
      headers
    );
  }
}
